import Currency from "./Currency"

enum E_TYPE_ID {
    GIFT    = 10,
    SYSTEM  = 20,
    SYSTEM_ITEM  = 21,
    SYSTEM_COINS  = 22,
    SYSTEM_ITEM_SELL  = 25,

    PUBLIC  = 30,
    PRIVATE = 40,
    PURCHASE_FACEBOOK = 50,
}



export default class TradeOffer {
    uuid:string

    created:string
    created_timestamp:number

    valid_after_timestamp:number | null
    valid_before_timestamp:number | null

    player_from_uuid:string | null
    player_to_uuid:string | null
    

    currency_from_id:number   // this is what author want's
    value_from      :number

    currency_to_id  :number   // this is what you will receive
    value_to        :number


    limit:number | null          // limitiation 
    type_id: E_TYPE_ID   
    typeString:string
    caption:string

    // canExecute 
    // product_id:  for fb
    private _currencyFrom: Currency
    private _currencyTo: Currency

    constructor(data:any) {
        Object.assign(this, data);                 
    }    

    get currencyFrom() {return this._currencyFrom}
    set currencyFrom(value:Currency|any) {
        if(typeof value != Currency.prototype.name) 
            value = value ? new Currency(value): value;        
        this._currencyFrom = value;
    }

    get currencyTo() {return this._currencyTo}
    set currencyTo(value:Currency|any) {
        if(typeof value != Currency.prototype.name) 
            value = value ? new Currency(value): value;        
        this._currencyTo = value;
    }


    isGift() {return this.type_id == E_TYPE_ID.GIFT;}
    isSystemItem() {return this.type_id == E_TYPE_ID.SYSTEM_ITEM;}
    isSystemCoin() {return this.type_id == E_TYPE_ID.SYSTEM_COINS;}    

    isTimeAvailable(serverTimestamp:number) {
        if(!this.valid_after_timestamp && !this.valid_before_timestamp)
            return true;        
                
        if(this.valid_after_timestamp && this.valid_after_timestamp > serverTimestamp)             
            return false;
            
        if(this.valid_before_timestamp && this.valid_before_timestamp < serverTimestamp)             
            return false;        

        return true;
    }
}




// uuid: "8e7eeda7-6c9b-44e2-986d-f376aaa4b1bb"
// created: "2019-11-12 16:19:29+03"
// created_timestamp: 1573564769
// valid_after_timestamp: null
// valid_before_timestamp: null
// player_from_uuid: null
// player_to_uuid: null
// currency_from_id: 643
// value_from: 12000
// currency_to_id: 10011
// value_to: 20000
// limit: null
// type_id: 22
// typeString: "system_coins"
// caption: "system_coins 120.00 RUB to 20000 Cr"
// canExecute: true
// product_id: null
// currencyFrom: {id: 643, entity: "RUSSIAN FEDERATION (THE)", name: "Russian Ruble", code_name: "RUB", minor_unit: 2, …}
// currencyTo: {id: 10011, entity: "5starsgammon", name: "Credit", code_name: "Cr", minor_unit: 0, …}
// __proto__: Object